// Components==============
import React from 'react';
import './Toggle.module.scss';
import { motion } from 'framer-motion';
// =========================

export default function Toggle({
  isToggled,
  setIsToggled,
}: {
  isToggled: boolean;
  setIsToggled?: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  return (
    <div
      styleName={`wrapper ${isToggled ? 'is-toggled' : ''} ${
        setIsToggled ? '' : 'inactive'
      }`}
      onClick={setIsToggled ? () => setIsToggled((prev) => !prev) : undefined}
    >
      <motion.div
        styleName="circle"
        initial={isToggled ? { x: 23 } : { x: 0 }}
        animate={isToggled ? { x: 23 } : { x: 0 }}
        transition={{
          type: 'spring',
          stiffness: 700,
          damping: 30,
        }}
      />
    </div>
  );
}
